import { api } from '@here/api'

// Get all notifications
export const handleGetNotifications = async (userId: string) => {
	const { data, error } = await api()
		.from('notification')
		.select('*')
		.eq('user_id', userId)

	if (error) {
		console.error('Error fetching notifications:', error)
		return []
	}

	return data
}

// Delete a notification by ID
export const handleDeleteNotification = async (notificationId: string | null) => {
	if (!notificationId) return

	const { error } = await api().from('notification').delete().eq('id', notificationId)

	if (error) {
		console.error('Error deleting notification:', error)
		return { success: false }
	}

	return { success: true }
}
